var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elevation-0",on:{"click":_vm.download}},[_vm._t("default",null,null,{ loading: _vm.loading }),_c('a',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"anchor",attrs:{"href":_vm.href,"download":_vm.computedName,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }